import './financeExperience.css';
import React from "react";
import EmptyState from "../../../components/common/EmptyState.jsx";
import StatusBadge from "../../../components/common/StatusBadge.jsx";
import ActionButton from "../../../components/common/ActionButton.jsx";

export default function InvoiceCenter(props) {
  const {
    loading,
    viewportWidth,
    metrics,
    cardStyle,
    sectionTitle,

    invoiceDateFrom,
    invoiceDateTo,
    setInvoiceDateFrom,
    setInvoiceDateTo,

    billingRates,
    setBillingRates,
    canViewRates,
    canEditRates,
    showBillingRates,

    invoiceDrafts,
    invoices,

    sending,

    generateSingleInvoice,
    exportInvoicePdf,

emailInvoice,
submitInvoiceForFunding,

selectedFundingCompany,
setSelectedFundingCompany,
factoringCompanies,

handleMarkInvoiceSent,

    handleMarkInvoicePaid,
    handleVoidInvoice,

    canGenerateInvoices,
    canMarkInvoicesPaid,
    canVoidInvoices,

    fmtMoney,
    fmtHours,
    fmtDate,

    buttonBaseStyle,
    primaryButtonStyle,

    MetricCard,
  } = props;

  return (
    <section className="finance-workspace" aria-label="Invoices">
      <header className="finance-heading"><div><span className="finance-kicker">Finance / Receivables</span><h2>Invoice workspace</h2><p>Billing periods, payment deadlines and collection status.</p></div></header>
               <div style={{ display: "grid", gap: 12 }}>
            <div
              style={{
                display: "grid",
                gridTemplateColumns:
                  viewportWidth < 650
                    ? "1fr"
                    : viewportWidth < 1050
                      ? "1fr 1fr"
                      : "repeat(6, 1fr)",
                gap: 12,
              }}
            >
              <MetricCard label="Coverage" value={metrics.total} helper="Current filtered view" />
              <MetricCard label="Open" value={metrics.open} helper="Still unfilled" />
              <MetricCard
                label="Workers Active"
                value={metrics.assigned}
                helper="Assigned / activated / arrived"
              />
              <MetricCard label="Completed Today" value={metrics.completed} helper="Finished shifts" />
              <MetricCard
                label="Hours Today"
                value={fmtHours(metrics.completedHours)}
                helper="Paid service hours"
              />
              <MetricCard
                label="Revenue Today"
                value={fmtMoney(metrics.projectedRevenue)}
                helper="Based on completed shifts"
              />
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: viewportWidth < 1100 ? "1fr" : "minmax(0, 3fr) minmax(0, 2fr)",
                alignItems: "start",
                gap: 12,
              }}
            >
              <div style={{ ...cardStyle(), padding: 14 }}>
                {sectionTitle(
                  "DogeBridge invoice generator",
                  "Build facility invoices from completed unbilled shifts"
                )}

                <div style={{ marginTop: 12, display: "grid", gap: 10 }}>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: viewportWidth < 700 ? "1fr" : "1fr 1fr",
                      gap: 10,
                    }}
                  >
                    <div>
                      <label
                        style={{
                          display: "block",
                          color: "#64748b",
                          fontSize: 12,
                          fontWeight: 800,
                          marginBottom: 4,
                        }}
                      >
                        From
                      </label>
                      <input
                        type="date"
                        value={invoiceDateFrom}
                        onChange={(e) => setInvoiceDateFrom(e.target.value)}
                        style={{
                          width: "100%",
                          height: 38,
                          borderRadius: 10,
                          border: "1px solid #d8e1ea",
                          padding: "0 10px",
                          fontWeight: 800,
                        }}
                      />
                    </div>

                    <div>
                      <label
                        style={{
                          display: "block",
                          color: "#64748b",
                          fontSize: 12,
                          fontWeight: 800,
                          marginBottom: 4,
                        }}
                      >
                        To
                      </label>
                      <input
                        type="date"
                        value={invoiceDateTo}
                        onChange={(e) => setInvoiceDateTo(e.target.value)}
                        style={{
                          width: "100%",
                          height: 38,
                          borderRadius: 10,
                          border: "1px solid #d8e1ea",
                          padding: "0 10px",
                          fontWeight: 800,
                        }}
                      />
                    </div>
                  </div>
{canViewRates ? (
  <>
    <div
      style={{
        fontWeight: 900,
        fontSize: 14,
        color: "#0f172a",
      }}
    >
      Billing Rates
    </div>

    {showBillingRates ? (
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(130px, 1fr))",
          gap: 8,
        }}
      >
        {Object.keys(billingRates).map((rk) => (
          <div key={rk}>
            <label
              style={{
                display: "block",
                color: "#64748b",
                fontSize: 11,
                fontWeight: 800,
                marginBottom: 4,
              }}
            >
              {rk}
            </label>

            <input
              type="number"
              min="0"
              step="0.01"
              value={billingRates[rk]}
              disabled={!canEditRates}
              onChange={(e) =>
                setBillingRates((prev) => ({
                  ...prev,
                  [rk]: Number(e.target.value || 0),
                }))
              }
              style={{
                width: "100%",
                height: 38,
                borderRadius: 10,
                border: "1px solid #d8e1ea",
                padding: "0 10px",
                fontWeight: 800,
                background: canEditRates ? "#ffffff" : "#f8fafc",
                color: canEditRates ? "#0f172a" : "#64748b",
                cursor: canEditRates ? "text" : "not-allowed",
              }}
            />
          </div>
        ))}
      </div>
    ) : null}
  </>
) : null}

<label style={{ fontWeight: 800 }}>
  Funding Company
</label>

<select
  value={selectedFundingCompany}
  onChange={(e) => setSelectedFundingCompany(e.target.value)}
  style={{
    height: 38,
    borderRadius: 10,
    border: "1px solid #d8e1ea",
    padding: "0 10px",
    fontWeight: 700,
  }}
>
  {factoringCompanies.map((c) => (
    <option key={c.id} value={c.id}>
      {c.name}
    </option>
  ))}
</select>

                  <div style={{ color: "#64748b", fontSize: 12, fontWeight: 800 }}>
                    Generate invoices one facility at a time from the draft list below.
                  </div>

                  <div style={{ display: "grid", gap: 8 }}>
                    {invoiceDrafts.length === 0 ? (
                      <div style={{ color: "#64748b", fontWeight: 800 }}>
                        No completed unbilled shifts found for the selected invoice date range.
                      </div>
                    ) : (
                      invoiceDrafts.map((inv) => (
                        <div
                          key={inv.facilityId}
                          style={{
                            border: "1px solid #e5e7eb",
                            borderRadius: 12,
                            padding: 10,
                            background: "#fff",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              gap: 10,
                              alignItems: "center",
                              flexWrap: "wrap",
                            }}
                          >
                            <div>
                              <div
                                style={{
                                  fontWeight: 900,
                                  color: "#0f172a",
                                  fontSize: 14,
                                }}
                              >
                                {inv.facilityName}
                              </div>
                              <div
                                style={{
                                  color: "#64748b",
                                  fontSize: 12,
                                  fontWeight: 700,
                                  marginTop: 2,
                                }}
                              >
                                {inv.shifts.length} completed shift
                                {inv.shifts.length === 1 ? "" : "s"}
                              </div>
                            </div>

                            <div style={{ textAlign: "right" }}>
                              <div style={{ fontWeight: 900, color: "#0f172a" }}>
                                {fmtMoney(inv.totalAmount)}
                              </div>
                              <div
                                style={{
                                  color: "#64748b",
                                  fontSize: 12,
                                  fontWeight: 700,
                                }}
                              >
                                {fmtHours(inv.totalHours)}
                              </div>
                            </div>

                        {canGenerateInvoices && (
                              <button
                                disabled={sending}
                                onClick={() => generateSingleInvoice(inv)}
                                style={{
                                  ...(sending ? buttonBaseStyle() : primaryButtonStyle()),
                                  padding: "9px 12px",
                                  borderRadius: 10,
                                  opacity: sending ? 0.7 : 1,
                                  cursor: sending ? "default" : "pointer",
                                }}
                              >
                                {sending ? "Creating…" : "Create Invoice"}
                              </button>
                            )}
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                </div>
              </div>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns:
                    "repeat(2, minmax(0, 1fr))",
                  gap: 12,
                }}
              >
                {[
                  {
                    label: "Outstanding",
                    value: fmtMoney(
                      invoices
                        .filter((inv) => !["paid", "void"].includes(String(inv.status || "").toLowerCase()))
                        .reduce((sum, inv) => sum + Number(inv.totalAmount ?? inv.total ?? 0), 0)
                    ),
                    color: "#b45309",
                    bg: "#fff7ed",
                    border: "#fdba74",
                  },
                  {
                    label: "Paid This Month",
                    value: fmtMoney(
                      invoices
                        .filter((inv) => String(inv.status || "").toLowerCase() === "paid")
                        .filter((inv) => {
                          const d = inv.paidAt?.toDate ? inv.paidAt.toDate() : new Date(inv.paidAt || inv.updatedAt || inv.createdAt);
                          const now = new Date();
                          return d.getMonth() === now.getMonth() && d.getFullYear() === now.getFullYear();
                        })
                        .reduce((sum, inv) => sum + Number(inv.totalAmount ?? inv.total ?? 0), 0)
                    ),
                    color: "#166534",
                    bg: "#ecfdf5",
                    border: "#86efac",
                  },
                  {
                    label: "Draft Count",
                    value: invoices.filter((inv) => String(inv.status || "draft").toLowerCase() === "draft").length,
                    color: "#1d4ed8",
                    bg: "#eff6ff",
                    border: "#93c5fd",
                  },
                  {
                    label: "Avg Invoice",
                    value: fmtMoney(
                      invoices.length
                        ? invoices.reduce((sum, inv) => sum + Number(inv.totalAmount ?? inv.total ?? 0), 0) /
                        invoices.length
                        : 0
                    ),
                    color: "#7c3aed",
                    bg: "#f5f3ff",
                    border: "#c4b5fd",
                  },
                ].map((item) => (
                  <div
                    key={item.label}
                    style={{
                      background: item.bg,
                      border: `1px solid ${item.border}`,
                      borderRadius: 16,
                      padding: "12px 14px",
                      boxShadow: "0 6px 16px rgba(15,23,42,.045)",
                    }}
                  >
                    <div
                      style={{
                        fontSize: 11,
                        fontWeight: 900,
                        textTransform: "uppercase",
                        color: "#475569",
                        letterSpacing: 0.35,
                      }}
                    >
                      {item.label}
                    </div>

                    <div
                      style={{
                        marginTop: 6,
                        fontSize: 21,
                        fontWeight: 950,
                        color: item.color,
                        lineHeight: 1,
                      }}
                    >
                      {item.value}
                    </div>
                  </div>
                ))}
              </div>

              <div style={{ display: "grid", gap: 12 }}>
                <div style={{ ...cardStyle(), padding: 14 }}>
                  {sectionTitle("Saved invoices", "Draft, sent, paid, and void invoice records")}
                  <div style={{ marginTop: 12, display: "grid", gap: 8 }}>
                    {invoices.length === 0 ? (
                      <EmptyState title="No invoices yet." />
                    ) : (
                      invoices.map((inv) => {
                        const isVoided = String(inv.status || "").toLowerCase() === "void";

                          const invoiceBadge = isVoided ? (
                              <StatusBadge label="VOIDED" tone="danger" />
                          ) : null;
                        const invoiceLines = Array.isArray(inv.lines)
                          ? inv.lines
                          : Array.isArray(inv.lineItems)
                            ? inv.lineItems
                            : [];

                        const invoiceTotal =
                          Number(inv.totalAmount ?? inv.total ?? 0) ||
                          invoiceLines.reduce(
                            (sum, item) => sum + Number(item.lineTotal || item.amount || 0),
                            0
                          );

                        const invoiceHours =
                          Number(inv.totalHours || 0) ||
                          invoiceLines.reduce((sum, item) => sum + Number(item.hours || 0), 0);

                        return (
                          <div
                            key={inv.id} className="finance-ledger-row"
                            style={{
                              border: "1px solid #e5e7eb",
                              borderRadius: 12,
                              padding: 10,
                              background: "#fff",
                            }}
                          >
                            {invoiceBadge}
                          
                            <div
                              style={{
                                display: "grid",
                                gridTemplateColumns:
                                  viewportWidth < 900 ? "1fr" : "1.4fr .8fr 1.2fr",
                                gap: 10,
                                alignItems: "center",
                              }}
                            >
                              <div>
                                <div
                                  style={{
                                    fontWeight: 900,
                                    color: "#0f172a",
                                    fontSize: 14,
                                  }}
                                >
                                  {inv.facilityName || inv.facilityId}
                                </div>

                                <div
                                  style={{
                                    color: "#334155",
                                    fontSize: 12,
                                    fontWeight: 800,
                                    marginTop: 4,
                                  }}
                                >
                                  Invoice #: {inv.invoiceNumber || "—"}
                                </div>

                                <div
                                  style={{
                                    color: "#64748b",
                                    fontSize: 12,
                                    fontWeight: 700,
                                    marginTop: 2,
                                  }}
                                >
                                  Issued / invoice date: {fmtDate(inv.invoiceDate || inv.createdAt)}
                                </div>

                                <div
                                  style={{
                                    color: "#64748b",
                                    fontSize: 12,
                                    fontWeight: 700,
                                    marginTop: 2,
                                  }}
                                >
                                  Due date: {fmtDate(inv.dueDate)}<br />Paid date: {inv.paidAt ? fmtDate(inv.paidAt) : "Not paid"}<br />Aging: {invoiceAging(inv)}
                                </div>

                                <div
                                  style={{
                                    color: "#64748b",
                                    fontSize: 12,
                                    fontWeight: 700,
                                    marginTop: 2,
                                  }}
                                >
                                  Billing: {fmtDate(inv.weekStart || inv.billingStart)} →{" "}
                                  {fmtDate(inv.weekEnd || inv.billingEnd)}
                                </div>

                                <div
                                  style={{
                                    marginTop: 6,
                                    display: "flex",
                                    gap: 6,
                                    flexWrap: "wrap",
                                  }}
                                >
                                 <StatusBadge
  label={invoiceDisplayStatus(inv)}
  tone={
    inv.status === "paid"
      ? "success"
      : inv.status === "sent"
      ? "info"
      : inv.status === "void"
      ? "danger"
      : "neutral"
  }
/>   

<StatusBadge
  label={String(inv.fundingStatus || inv.factoringStatus || "not_submitted")
    .replaceAll("_", " ")
    .toUpperCase()}
  tone="warning"
/>

                                </div>
                              </div>

                              <div>
                                <div style={{ fontWeight: 900, color: "#0f172a" }}>
                                  {fmtMoney(invoiceTotal)}
                                </div>

                                <div
                                  style={{
                                    color: "#64748b",
                                    fontSize: 12,
                                    fontWeight: 700,
                                  }}
                                >
                                  {fmtHours(invoiceHours)}
                                </div>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  gap: 6,
                                  flexWrap: "wrap",
                                  justifyContent:
                                    viewportWidth < 800 ? "flex-start" : "flex-end",
                                }}
                              >
                                        <ActionButton
                                            disabled={isVoided}
                                            onClick={() => exportInvoicePdf(inv)}
                                        >
                                            Export PDF
                                        </ActionButton>

                                        <ActionButton
                                            disabled={isVoided}
                                            onClick={() => emailInvoice(inv)}
                                        >
                                            Email Facility
                                        </ActionButton>

                                {canGenerateInvoices && (
                                  <button
                                    style={buttonBaseStyle()}
                                    onClick={() => submitInvoiceForFunding(inv)}
                                    disabled={isVoided}
                                  >
                                    Submit for Funding
                                  </button>
                                )}

                                {canGenerateInvoices && (
                                  <button
                                    style={buttonBaseStyle()}
                                    onClick={() => handleMarkInvoiceSent(inv.id)}
                                    disabled={isVoided}
                                  >
                                    Mark sent
                                  </button>
                                )}

                                {canMarkInvoicesPaid && (
                                  <button
                                    style={buttonBaseStyle()}
                                    onClick={() => handleMarkInvoicePaid(inv.id)}
                                    disabled={isVoided}
                                  >
                                    Mark paid
                                  </button>
                                )}

                                {canVoidInvoices && (
                                  <button
                                    disabled={isVoided}
                                    style={{
                                      ...buttonBaseStyle(),
                                      background: isVoided ? "#f1f5f9" : "#fef2f2",
                                      border: isVoided ? "1px solid #cbd5e1" : "1px solid #fecaca",
                                      color: isVoided ? "#64748b" : "#991b1b",
                                      cursor: isVoided ? "not-allowed" : "pointer",
                                      opacity: isVoided ? 0.75 : 1,
                                    }}
                                    onClick={() => {
                                      if (isVoided) return;
                                      handleVoidInvoice(inv.id);
                                    }}
                                  >
                                    {isVoided ? "Voided" : "Void"}
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        );
                      })
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
    </section>
  );
}
function invoiceAging(inv) {
  if (['paid','void','draft'].includes(String(inv.status || 'draft').toLowerCase())) return '�';
  const due = inv.dueDate?.toDate ? inv.dueDate.toDate() : new Date(inv.dueDate);
  if (!Number.isFinite(due.getTime())) return 'Unavailable';
  const days = Math.floor((Date.now() - due.getTime()) / 86400000);
  return days > 0 ? `${days} days past due` : 'Within terms';
}
function invoiceDisplayStatus(inv) {
  const status = String(inv.status || 'draft').toLowerCase();
  if (['paid','void','draft'].includes(status)) return status.toUpperCase();
  if (invoiceAging(inv).includes('past due')) return 'PAST DUE';
  return status === 'sent' || status === 'issued' ? 'ISSUED' : status.toUpperCase();
}
